import React from 'react';
import clsx from 'clsx';
import {useHistory} from 'react-router-dom';
import {makeStyles} from '@material-ui/core/styles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import PropTypes from 'prop-types';
import {KEYS, VALUES} from './util';

const useStyles = makeStyles((t) => ({
  currentStep: {
    fontWeight: 700,
  },
  click: {
    cursor: 'pointer',
  },
}));

CheckoutBreadcrumbs.propTypes = {
  step: PropTypes.string,
};

function CheckoutBreadcrumbs({step}) {
  const history = useHistory();
  const classes = useStyles();

  return (
    <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
      <Typography>Carrito</Typography>
      {VALUES.map((it, i) => {
        const isClick = KEYS.findIndex((it) => it === step) >= i;
        return (
          <Typography
            key={i}
            className={clsx({
              [classes.currentStep]: step === KEYS[i],
              [classes.click]: isClick,
            })}
            {...(isClick
              ? {
                  onClick: () => {
                    history.push(`/checkout/${KEYS[i]}`);
                  },
                }
              : {})}
          >
            {it}
          </Typography>
        );
      })}
    </Breadcrumbs>
  );
}

export default CheckoutBreadcrumbs;
